import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ConfigService } from '../../Services/ConfigService';
import { PersonRoleEnum } from '../../Models/OtherClasses';
import { CompanyAnnouncementService } from '../../Services/Custom/ServiceCompanyAnnouncement';

@Component({
	selector: 'admin-menu',
	templateUrl: 'AdminMenu.html',
	moduleId: module.id
})
export class AdminMenuComponent implements OnInit {
	ngOnInit(): void {
		this.isAdmin = this.configData.IsUserInRole(PersonRoleEnum.SUPERADMIN);
		this.isSuperAdmin = this.configData.isSuperAdmin;
		this.router.events.subscribe((val) => {
			if (this.lastPull < Date.now() - 2000) {
				this.loadAnnouncements();
			}
		});
	}

	isSuperAdmin: boolean = false;
	isAdmin = false;
	menuVisible = false;
	lastPull: number = 0;

	constructor(
		private router: Router,
		public configData: ConfigService,
		private myAnnoucementService: CompanyAnnouncementService,
		private route: ActivatedRoute) {
	}

	loadAnnouncements() {

		var thisHolder = this;
		thisHolder.lastPull = Date.now();
		this.myAnnoucementService.loadAllForMe()
			.subscribe(anCol => {
				thisHolder.announcements = anCol;
			});

	}

	announcements: ePM.Logic.CompanyAnnouncement[] = [];
}